const { createContext } = require("react");


const contactContext = createContext();

export default contactContext;